module.exports = __webpack_public_path__ + "img/new-step4.8159568b.jpg";